export interface FilterOrExpression {
    operator: OperatorType.Or;
    conditions: FilterExpression[];
}

export interface FilterEqualExpression {
    operator: OperatorType.Equal;
    condition: CompareWithConstantCondition;
}

export interface FilterEqualExpression {
    operator: OperatorType.Equal;
    condition: CompareWithConstantCondition;
}

export interface FilterStartDateExpression {
    operator: OperatorType.StartDate;
    condition: CompareWithConstantCondition;
}

export interface FilterEndDateExpression {
    operator: OperatorType.EndDate;
    condition: CompareWithConstantCondition;
}

export interface FilterLessOrEqualExpression {
    operator: OperatorType.LessOrEqual;
    condition: CompareWithConstantCondition;
}

export interface FilterGreaterOrEqualExpression {
    operator: OperatorType.GreaterOrEqual;
    condition: CompareWithConstantCondition;
}

export interface FilterSubstringExpression {
    operator: OperatorType.Substring;
    condition: CompareWithConstantCondition;
}

export interface FilterByInstancesExpression {
    operator: OperatorType.ByInstances;
    condition: CompareWithInstancesCondition;
}

export interface FilterAndExpression {
    operator: OperatorType.And;
    conditions: FilterExpression[];
}

export interface FilterUnaryNotExpression {
    operator: OperatorType.UnaryNot;
    condition: FilterExpression;
}

export function isSubstringExpression(x: undefined | FilterExpression): x is FilterSubstringExpression {
    return x != undefined && x.operator === OperatorType.Substring;
}

export function isStartDateExpression(x: undefined | FilterExpression): x is FilterStartDateExpression {
    return x != undefined && x.operator === OperatorType.StartDate;
}

export function isEndDateExpression(x: undefined | FilterExpression): x is FilterEndDateExpression {
    return x != undefined && x.operator === OperatorType.EndDate;
}

export function isOrExpression(x: undefined | FilterExpression): x is FilterOrExpression {
    return x != undefined && x.operator === OperatorType.Or;
}

export function isAndExpression(x: undefined | FilterExpression): x is FilterAndExpression {
    return x != undefined && x.operator === OperatorType.And;
}

export function isEqualExpression(x: undefined | FilterExpression): x is FilterEqualExpression {
    return x != undefined && x.operator === OperatorType.Equal;
}

export function isBinaryExpression(
    x: undefined | FilterExpression
): x is FilterEqualExpression | FilterStartDateExpression | FilterEndDateExpression | FilterSubstringExpression {
    return (
        x != undefined &&
        (x.operator === OperatorType.Equal ||
            isEndDateExpression(x) ||
            isStartDateExpression(x) ||
            x.operator === OperatorType.Substring)
    );
}

export type FilterExpression =
    | FilterEqualExpression
    | FilterStartDateExpression
    | FilterEndDateExpression
    | FilterSubstringExpression
    | FilterAndExpression
    | FilterOrExpression
    | FilterUnaryNotExpression
    | FilterByInstancesExpression
    | FilterLessOrEqualExpression
    | FilterGreaterOrEqualExpression;

export interface CompareWithConstantCondition {
    dataPath: string;
    value: string;
}

export interface CompareWithInstancesCondition {
    dataPath: string;
    instances: string[];
}

export enum OperatorType {
    UnaryNot = "unaryNot",
    And = "and",
    Or = "or",
    Equal = "equal",
    StartDate = "startDate",
    EndDate = "endDate",
    Substring = "substring",
    ByInstances = "byInstances",
    LessOrEqual = "lessOrEqual",
    GreaterOrEqual = "greaterOrEqual",
}

export enum FilterType {
    Substring = "substring",
    Equal = "equal",
    DateRange = "dateRange",
}
